import {
  USER_OPENED_ZIP_CODE_MODAL,
  USER_UPDATED_ZIP_CODE,
  USER_UPDATED_ZIP_CODE_ERROR,
  PRELOAD_DMA,
  GET_DMA,
  GET_DMA_FAILED,
  GET_DMA_SUCCEEDED,
} from '../constants';

import { getTermFromState } from '../selectors/i18n';
import { get, isValidZip, setCookie } from '../../utils';
import { getDMADetails } from '../../services';
import getBrandConfig from '../../../config/brand';

const brandConfig = getBrandConfig(process.env.BRAND_CHANNEL, process.env.LANG, process.env.SLOT, process.env.VENDOR); // eslint-disable-line
const ZipCodeCookie = brandConfig.cookies.zipCode;

/**
 * This call sends the zipcode to the Dealer Center service and
 * returns a dma object with location data
 * @param zipCode - The users zipcode from url, cookie or entered in
 * @param state - The Redux store
 * @param dispatch - The dispatch action
 */
const loadDmaFromService = (zipCode, state, dispatch) => new Promise((resolve, reject) => {
    // 2- Load DMA from service
  dispatch({
    type: GET_DMA,
    zipCode
  });
  getDMADetails(state, zipCode)
    .then((dma) => {
      if (dma[0]) { // If there is an array returned it will be an error
        reject(dma[0].error.code); // Send in the Error code for debugging
      }
      dispatch({
        type: GET_DMA_SUCCEEDED,
        result: dma
      });
      resolve(dma);
    })
    .catch((error) => {
      dispatch({
        type: GET_DMA_FAILED,
        error
      });
      reject(error)
    });
})

/**
 * If there is a Zipcode in cookie pre-load it into the state
 * @returns {function(*=, *)}
 */
export function preloadDMAInfo() {
  return (dispatch, getState) => {
    const state = getState();
    const zipCode = get(state, 'dma.zipCode');
    if (!zipCode) {
      return;
    }
    dispatch({
      type: PRELOAD_DMA,
    });
    loadDmaFromService(zipCode, getState(), dispatch);
  }
}

/**
 * Action to let us know the user has opened the modal (for MKS)
 * @returns {function(*)}
 */
export function openZipModalUserAction() {
  return (dispatch) => {
    dispatch({
      type: USER_OPENED_ZIP_CODE_MODAL
    });
  };
}

/**
 * Update the Zipcode in the store as well as set the cookie
 * @param zipCode - The users entered zipcode
 * @returns {function(*=, *)}
 */
export function updateZipCodeAction(zipCode) {
  return (dispatch, getState) => {
    const zipCodeValue = zipCode;
    // 1- Validate ZipCode
    if (!isValidZip(zipCodeValue)) {
      dispatch({
        type: USER_UPDATED_ZIP_CODE_ERROR,
        errorMsg: getTermFromState(getState(), 'zipCodeModal.zipError')
      });
      return;
    }
    loadDmaFromService(zipCodeValue, getState(), dispatch).then(() => {
      // 3- Write value to cookies
      setCookie(ZipCodeCookie, zipCodeValue, { expires: 365 });
      dispatch({
        type: USER_UPDATED_ZIP_CODE,
        zipCode
      });
    })
    .catch(() => {
      dispatch({
        type: USER_UPDATED_ZIP_CODE_ERROR,
        errorMsg: getTermFromState(getState(), 'zipCodeModal.zipError')
      });
    })
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/zipCode.js
 **/